import useApi from "hooks/use_api"

const useAttendeeTypes = eventId => {
  return useApi({
    path: `events/${eventId}/attendee_types`,
    data: { fields: { AttendeeType: "name" } }
  })
}

export default useAttendeeTypes
